// ============================================================
// STAFF DATA - me file eken okkoma staff details update karanna.
// Aluth kenek add karanna: array ekata { ... } block ekak copy-paste karanna.
// Profile page eke education / specialization / email maru karanna:
//   pahalata qualifications / specializations array eka edit karanna witharai.
// ============================================================

export const staffMembers = [
  {
    id: "card-1",
    slug: "ekanayake",
    name: "Chaminda Ekanayake",
    role: "Webmaster (Acting)",
    photo: "/ekanayake.jpg",
    photoAlt: "Chaminda Ekanayake",
    photoPosition: "center 12%",
    stripeClass: "stripe-maroon",
    email: "webmaster@gs.pdn.ac.lk",
    qualifications: [
      "CCNA (Academy Program)",
      "MCP — Microsoft Certified Professional",
      "Post Graduate Diploma in IT — 1st Class, Indian Institute of Management & Technology",
      "AUKAP (UK) — Associate Member, United Kingdom Association of Professionals",
    ],
    specializations: [
      "Networking",
      "Web Development",
      "Moodle Administration",
      "Instructional Designing",
      "Graphic Designing",
      "Photography",
    ],
  },
  // ------------------------------------------------------------
  // ALUTH 2 DENNA - me deka edit karala nama/role/photo danna.
  // Photo: public/ folder ekata jpg eka dala photo: "/filename.jpg" kiyala danna.
  // Photo nathnam photo: "" kiyala thiyanna - placeholder icon eka penawa.
  // ------------------------------------------------------------
  {
    id: "card-3",
    slug: "nugaliyadda",
    name: "N.K.D Chamara Nugaliyadda",
    role: "Audio Visual Technical Officer",
    positionRole: "Audio Visual Productions",
    photo: "/member4.jpg",
    photoAlt: "N.K.D Chamara Nugaliyadda",
    photoPosition: "center 12%",
    stripeClass: "stripe-green",
    email: "nugaliyadda@gs.pdn.ac.lk",
    qualifications: [
      "B.PA (Applied Music & Mass Communication)",
      "MA (Mass Communication)",
      "Dip. Audio Engineer",
    ],
    specializations: [
      "Video Productions",
      "Audio Mix and Mastering",
      "Script Writing",
      "Making Music",
    ],
  },
  {
    id: "card-4",
    slug: "senevirathne",
    name: "Dananjaya Senevirathne",
    role: "Audio Visual Technical Officer",
    photo: "/member3.jpg",
    photoAlt: "Dananjaya Senevirathne",
    photoPosition: "center 12%",
    stripeClass: "stripe-maroon",
    email: "dananjayas@gs.pdn.ac.lk",
    qualifications: [
      "B.Technology Film & Television Production Technology (UOVT)",
      "National Diploma in Television Programme Production Technology (UOVT)",
      "Microsoft Certified Professional",
    ],
    specializations: [
      "Photography",
      "Videography",
      "Cinematography",
      "Live Event Broadcasting",
      "Television Programme",
      "Graphic Design",
      "Editing",
    ],
  },
];

export const getStaffBySlug = (slug) =>
  staffMembers.find((m) => m.slug === slug);
